import { createTheme } from '@mui/material/styles';
import { BaseMuiThemeComponentsSettings } from './toolympus/components/primitives/BaseThemeSettings';

export const ThemeSettings = {
  colors: {
    primary: "#22277d",
    primaryL1: "#0f1a3e", // main dark background
    secondary: "#da5a36",
    background: "#faf9f1",
    text: "#2c3963",
    textSecondary: "#0e173ba0",
  },
}


export const theme = createTheme({
    palette: {
        primary: {
            main: ThemeSettings.colors.secondary,
        },
        secondary: {
            main: ThemeSettings.colors.primary,
        },
        text: {
          primary: ThemeSettings.colors.text,
          secondary: ThemeSettings.colors.textSecondary,
        },
    },

    components: {
      ...BaseMuiThemeComponentsSettings,
    },
});
